module.exports = __webpack_public_path__ + "img/img_nav_bonus-w.74783bb0.svg";